// extracted by mini-css-extract-plugin
export default {"code":"G_db"};